import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Make focusable elements in the background unaccessible
    setTimeout(() => {
      const focusableElements = this.element.querySelectorAll(
        'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select',
      )
      focusableElements.forEach((element) => {
        element.setAttribute("tabindex", "-1")
      })
    }, 2000)
  }
}
